import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const clientes = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/customers', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function createItem(fornecedor) {
    try {
      const {data} = await http.post('/customers', fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      const {data} = await http.delete('/customers/'+id, auth.getBearer());
      return true;
    } catch (error) {
      return false;
      console.log(error?.response?.data);
    }
  }

  async function updateItem(fornecedor) {
    try {
      const {data} = await http.put('/customers/'+fornecedor.id, fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      return false;
      console.log(error?.response?.data);
    }
  }

  async function createAccount(id) {
    try {
      const {data} = await http.post('/customers/'+id+'/create-account', {}, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, createItem, deleteItem, updateItem,createAccount}
}
